module.exports = __webpack_public_path__ + "695ca83a133aa56420add02d27b48cc3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/9.png
// module id = 39
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18